<template>
  <div class="home">
    <HeaderBar/>
    <div class="main-wrap">
      <router-view></router-view>
    </div>
    <Footer id="contact"/>
  </div>
</template>
<script>
import HeaderBar from '@/components/HeaderBar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'layout',
  components: {
    HeaderBar,
    Footer
  }
}
</script>

